export const SIZES = {
    small: 'small',
    medium: 'medium',
};
export default ['', 'compact', 'compactSide', 'uniformSide', 'uniformFull'];
//# sourceMappingURL=tab-types.js.map